// Module
var code = `<section class="box">
  <form name="\$ctrl.form">
    <table class="table table--last-column-to-right">
      <thead>
      <tr>
        <th class="no-column-header">No</th>
        <th>Type</th>
        <th>Base on</th>
        <th>Minimum Loan Days late</th>
        <th>Days interval after previous letter</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
        <tr ng-repeat="item in \$ctrl.loanProduct.letters" ng-form name="\$ctrl['form_' + \$index]">
          <td>{{item.orderNo}}.</td>
          <td>
            <select
              required
              ng-disabled="!item.inputMode"
              ng-model="item.typeId"
              ng-options="type.id as type.name for type in \$ctrl.letterTypes">
            </select>
          </td>
          <td>
            <select
              required
              ng-disabled="!item.inputMode"
              ng-model="item.printBasis"
              ng-options="type.id as type.value for type in \$ctrl.getPrintBaseSelection(\$index)">
            </select>
          </td>
          <td>
            <input ng-disabled="!item.inputMode"
                   type="number"
                   required
                   min="0"
                   ng-model="item.minLoanDaysLate" />
          </td>
          <td>
            <input ng-disabled="!item.inputMode || \$index === 0"
                   type="number"
                   required
                   min="0"
                   ng-model="item.minDaysInterval" />
          </td>
          <td class="table__actions">
            <button ng-if="!item.inputMode && (\$index > 0 || \$ctrl.loanProduct.letters.length === 1)"
                    class="btn btn-danger pull-right"
                    type="button"
                    ng-click="\$ctrl.remove(\$index)">Remove</button>
            <button ng-if="!item.inputMode"
                    class="btn btn-warning pull-right"
                    type="button"
                    ng-click="\$ctrl.edit(\$index)">Edit</button>
            <button ng-if="item.inputMode"
                    class="btn btn-danger pull-right"
                    type="button"
                    ng-click="\$ctrl.cancel(\$index)">Cancel</button>
            <button ng-if="item.inputMode"
                    class="btn btn-success pull-right save-button"
                    type="button"
                    ng-click="\$ctrl.save(\$index)">Save</button>
          </td>
        </tr>
      </tbody>
      <tfoot>
      <tr>
        <td colspan="6" class="letter-list__add-new-column">
          <button class="btn btn-success" type="button" ng-click="\$ctrl.add()">
            Add
          </button>
        </td>
      </tr>
      </tfoot>
    </table>

  </form>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/loan/details/forms/loan-product-letters.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;